import { NestedTreeControl } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  inject,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule, MatTreeNestedDataSource } from '@angular/material/tree';
import { TooltipEllipsisDirective } from '../../directives/tooltip-ellipsis.directive';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
  RouterLink,
} from '@angular/router';
import {
  BehaviorSubject,
  Subject,
  Subscription,
  forkJoin,
  takeUntil,
  tap,
} from 'rxjs';
// import { LoaderService } from '../../../../services/loader.service';
import { AuthService } from '../../../login/services/auth.service';
import { ModalEmailSoporteComponent } from '../../../../components/modal-email-soporte/modal-email-soporte.component';
import { ModalController, PopoverController } from '@ionic/angular';
import { HomeService } from '../../services/home.service';
import { DataService } from 'src/app/services/data/data.service';
import { ResizableDrawerDirective } from '../../directives/resizable-drawer.directive';
import { NoTranslateMaterialSymbolsDirective } from '../../../../shared/directives/noTranslateMaterialSymbols.directive';
import { SkeletonMenuItemComponent } from './skeleton-menu-item.component';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { getMenuTreeData, SideNavNode } from './menu-items.data';
import {
  HIDRAULICA_GROUPS,
  isAdminOrSaasModule,
} from '../../../login/guards/module-access-policy';

@Component({
  selector: 'app-menu-items',
  imports: [
    CommonModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    TooltipEllipsisDirective,
    MatTooltipModule,
    RouterLink,
    NoTranslateMaterialSymbolsDirective,
    SkeletonMenuItemComponent,
  ],
  templateUrl: './menu-item.html',
  styleUrls: ['./menu-item.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0px',
          minHeight: '0',
          visibility: 'hidden',
          opacity: 0,
        })
      ),
      state(
        'expanded',
        style({ height: '*', visibility: 'visible', opacity: 1 })
      ),
      transition('expanded => collapsed', [
        animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ]),
      transition('collapsed => expanded', [
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'),
      ]),
    ]),
  ],
})
export class MenuItemsComponent implements OnChanges, OnDestroy, OnInit {
  public authService = inject(AuthService);
  public modalController = inject(ModalController);
  public popoverController = inject(PopoverController);
  public homeService = inject(HomeService);
  private _dataServices = inject(DataService);

  @Output() clickedLeaf: EventEmitter<any> = new EventEmitter<any>();
  private destroy = new Subject<void>();
  private router = inject(Router);
  public currentRoute = new BehaviorSubject<string>(this.router.url);
  /** Ruta marcada mientras dura la navegación iniciada desde el menú. */
  readonly navigatingRoute = signal<string | null>(null);
  public cantidadNotificacionesNoVistas = 0;
  public notificaciones = [];
  public num_socio!: number;
  public rol!: number;
  enableOptions: EnableOption[] = [];

  @ViewChild(ResizableDrawerDirective)
  drawerDirective!: ResizableDrawerDirective;

  get isExpanded(): boolean {
    return this.homeService.isExpanded;
  }

  set isExpanded(value: boolean) {
    this.homeService.isExpanded = value;
  }

  constructor() {
    // public loading: LoaderService,
    this.router.events.pipe(takeUntil(this.destroy)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute.next(event.urlAfterRedirects);
        this.navigatingRoute.set(null);
      }
      if (
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.navigatingRoute.set(null);
      }
    });
  }
  @Input() filteredItems: any;
  @Input() searchedItem: any;
  @Input() menuSize: any = 240;

  appTruncateText = true;

  treeControl = new NestedTreeControl<SideNavNode>(node => node?.children);
  dataSource = new MatTreeNestedDataSource<SideNavNode>();
  private expandedSubscription!: Subscription;

  ngOnInit() {
    this.isExpanded = true;
    const menuTreeData = getMenuTreeData();
    this.assignParents(menuTreeData);
    this.expandedSubscription = this.homeService
      .getExpanded()
      .subscribe(value => {
        if (!value) {
          this.collapseAll();
        }
      });
    forkJoin([
      this._dataServices.getEnabledMenuOpts().pipe(
        tap(enabledOpts => {
          this.enableOptions = enabledOpts?.modulos ?? [];
        })
      ),
    ]).subscribe({
      next: () => {
        const filteredByHidden = this.filterHiddenItems(menuTreeData);
        const filteredByPermissions =
          this.filterByPermissions(filteredByHidden);
        this.dataSource.data = this.filterItems(filteredByPermissions);
      },
      error: err => {
        console.error('Error cargando opciones del menú:', err);
        this.dataSource.data = this.filterItems(
          this.filterByPermissions(this.filterHiddenItems(menuTreeData))
        );
      },
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['menuSize'].currentValue > 145) {
      this.isExpanded = true;
    } else {
      this.isExpanded = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  hasChild = (_: number, node: SideNavNode) =>
    !!node.children && node.children.length > 0;

  expandNodes(
    nodes: SideNavNode[],
    searchedItem: string,
    parentExpanded: boolean = false
  ): void {
    if (searchedItem !== '') {
      nodes.forEach(node => {
        if (node.children) {
          let shouldExpandParent = false;

          node.children.forEach(child => {
            this.expandNodes([child], searchedItem, parentExpanded);

            if (child.children) {
              child.children.forEach(childChildren => {
                this.expandNodes([childChildren], searchedItem, parentExpanded);
                shouldExpandParent = true;
              });
            }

            if (
              child.name.toLowerCase().includes(searchedItem?.toLowerCase())
            ) {
              shouldExpandParent = true;
            }
          });

          if (shouldExpandParent) {
            this.treeControl.expand(node);
          }
        }

        if (
          node.name?.toLowerCase().includes(searchedItem?.toLowerCase()) &&
          !parentExpanded
        ) {
          // Expand the node if it matches the search item
          this.treeControl.expand(node);
        } else if (
          !node.children ||
          !this.hasMatchingChildrenRecursive(node.children, searchedItem)
        ) {
          // Collapse nodes that don't match the search and have no matching children
          this.treeControl.collapse(node);
        }
      });
    }
  }

  hasMatchingChildrenRecursive(
    children: SideNavNode[] | undefined,
    searchedItem: string
  ): boolean {
    if (!children) {
      return false;
    }

    return children.some(child => {
      if (child.name.toLowerCase().includes(searchedItem?.toLowerCase())) {
        return true;
      }

      return this.hasMatchingChildrenRecursive(child.children, searchedItem);
    });
  }

  collapseAll(): void {
    this.dataSource.data.forEach(node => {
      this.collapseNodeAndDescendants(node);
    });
  }

  collapseNodeAndDescendants(node: SideNavNode): void {
    this.treeControl.collapse(node);

    if (node.children) {
      node.children.forEach(child => {
        this.collapseNodeAndDescendants(child);
      });
    }
  }

  private hasPermission(permissions: string[] | undefined): boolean {
    if (!permissions || permissions.length === 0) {
      return true;
    }

    const userPermissions = [''];
    return permissions.some((permission: any) =>
      userPermissions.includes(permission)
    );
  }

  private hasPermissionInNode(node: SideNavNode): boolean {
    // If the node has permissions or permissions are not specified, it should be displayed
    if (
      !node.permissions ||
      (node.permissions && this.hasPermission(node.permissions))
    ) {
      // If the node has children, check if any child with permissions exists
      if (node.children) {
        // Filter out child nodes without permissions
        const childrenWithPermission = node.children.filter(child =>
          this.hasPermissionInNode(child)
        );

        // Update the children of the current node
        node.children = childrenWithPermission;

        // Return true if the node has either permissions or filtered children
        return (
          !node.permissions ||
          node.permissions.length > 0 ||
          childrenWithPermission.length > 0
        );
      }

      return true;
    }

    return false; // Return false if neither the node nor its children have permission
  }

  obtenerIDs(arregloObjetos: any[]): number[] {
    const filteredObjects = arregloObjetos.filter(
      objeto => objeto.web_status === 'new'
    );
    return arregloObjetos.map(objeto => objeto.id);
  }
  collapseExpandSelect(node: SideNavNode) {
    if (this.menuSize < 145 && this.menuSize) {
      this.homeService.setExpanded(true);
    }
    if (this.treeControl.isExpanded(node)) {
      // Si el nodo está expandido, colapsarlo
      this.treeControl.collapse(node);
    } else {
      this.collapseAll();
      // Si el nodo está colapsado, expandirlo
      this.treeControl.expand(node);
    }
  }
  collapseNotChildNotParent(node: SideNavNode) {
    // Verifica si el nodo no tiene descendientes
    const noDescendants = this.treeControl.getDescendants(node).length === 0;

    // Verifica si el nodo no tiene un padre
    const noParent = !node.parent;
    // Si no tiene descendientes ni padre, colapsa el nodo
    if (noDescendants && noParent) {
      this.collapseAll();
    }
  }
  assignParents(nodes: SideNavNode[], parent?: SideNavNode) {
    nodes.forEach(node => {
      node.parent = parent;
      if (node.children) {
        this.assignParents(node.children, node);
      }
    });
  }
  isActiveRoute(node: SideNavNode): boolean {
    return (
      this.currentRoute.value === node.routerLink ||
      this.currentRoute.value.startsWith(`${node.routerLink}/`)
    );
  }

  isChildActive(node: SideNavNode): boolean {
    if (!node.children) {
      return false;
    }
    return node.children.some(child => {
      return this.isActiveRoute(child) || this.isChildActive(child);
    });
  }
  private filterItems(items: SideNavNode[]): SideNavNode[] {
    const enabledIds = this.enableOptions.map(option =>
      option.id.toLowerCase()
    );
    const canToggleAdminOrSaas = this.authService.canToggleAdminOrSaasModules();
    const canOpenHidraulica =
      this.authService.hasAnyUserGroup(HIDRAULICA_GROUPS);

    const filterAndMarkEnabled = (
      nodes: SideNavNode[],
      isRoot: boolean = false
    ): SideNavNode[] => {
      return nodes.map((node, index) => {
        if (isRoot && index === 0) {
          node.enabled = true;
        } else if (
          node.id &&
          isAdminOrSaasModule(node.id) &&
          !canToggleAdminOrSaas
        ) {
          node.enabled = false;
        } else if (node.id === 'hidraulica' && !canOpenHidraulica) {
          node.enabled = false;
        } else {
          node.enabled = node.id ? enabledIds.includes(node.id) : false;
        }

        if (node.children) {
          const parentEnabled = node.enabled !== false;
          const followsParent =
            node.id === 'hidraulica' ||
            (!!node.id && isAdminOrSaasModule(node.id));
          node.children = node.children.map(child => {
            child.enabled = followsParent ? parentEnabled : true;
            return child;
          });
        }
        return node;
      });
    };
    return filterAndMarkEnabled(items, true);
  }

  /**
   * Función para filtrar y ocultar los elementos del menú que tienen `hide` en true.
   * @param nodes - Los nodos del árbol del menú.
   * @returns Los nodos filtrados sin los elementos ocultos.
   */
  filterHiddenItems(nodes: SideNavNode[]): SideNavNode[] {
    // Filtra los nodos que no tienen `hide` en true
    return nodes
      .filter(node => {
        const isHidden =
          typeof node.hide === 'function'
            ? node.hide(this.authService)
            : !!node.hide;

        return !isHidden;
      })
      .map(node => {
        // Si el nodo tiene hijos, aplica la misma función recursivamente
        if (node.children) {
          node.children = this.filterHiddenItems(node.children);
        }
        return node;
      });
  }

  private filterByPermissions(nodes: SideNavNode[]): SideNavNode[] {
    return nodes
      .filter(node => {
        // Si el nodo requiere permiso, verificar si el usuario lo tiene
        if (node.requiredPermission) {
          return this.authService.hasPermission(node.requiredPermission);
        }
        return true; // Si no requiere permiso, mostrarlo siempre
      })
      .map(node => ({
        ...node,
        children: node.children
          ? this.filterByPermissions(node.children)
          : undefined,
      }));
  }

  closeMenu() {
    this.clickedLeaf.emit();
  }

  isNavigatingTo(node: SideNavNode): boolean {
    const link = node.routerLink;
    return !!link && this.navigatingRoute() === link;
  }

  onMenuNavigate(node: SideNavNode): void {
    if (!node?.enabled || !node.routerLink) return;
    this.navigatingRoute.set(node.routerLink);
  }
}

interface EnableOption {
  id: string;
  // otras propiedades si existen
}
